module.exports = __webpack_public_path__ + "img/56cd8a2.png";